// Port EXACTO de la normalización de símbolos del backend para construir
// cellKeys "<SYMBOL>:<TF>" iguales que el backend (celdas de
// _bySymbolTf en trading_bot_indicator_configs y celdas de dispatch):
//
// - normalize_symbol (backend/app/schemas/telegram_subscriptions.py:42):
//     raw.strip().upper().replace("/", "")
// - _normalize_bot_symbol (backend/app/tasks/signal_card_tasks.py:960):
//     normalize_symbol(raw).split(":")[0]
//   BotConfig.symbol puede llegar en formato CCXT del wizard
//   ('BTC/USDT:USDT') o plano ('BTCUSDT'): ambos caen en la MISMA celda
//   ('BTCUSDT'). Sin el recorte del sufijo ':USDT' de perpetuos se
//   reproduciría el bug ya corregido una vez en backend
//   (tests/test_signal_card_bot_dispatch.py::
//   test_load_bot_subscriptions_normalizes_ccxt_and_plain_symbol_to_same_cell).
//
// OJO: las normalizaciones ad-hoc que hay repartidas por el frontend
// (ChartPage.jsx:108, BotsListPage.jsx:24, ...) NO son equivalentes — no
// usarlas para cellKeys.

export function normalizeSymbol(raw) {
  if (typeof raw !== 'string') return ''
  return raw.trim().toUpperCase().replace(/\//g, '')
}

export function normalizeBotSymbol(raw) {
  return normalizeSymbol(raw).split(':')[0]
}

// cellKey de una celda símbolo×timeframe, p.ej. cellKey('BTC/USDT:USDT', '1h')
// === cellKey('BTCUSDT', '1h') === 'BTCUSDT:1h'.
export function cellKey(symbol, timeframe) {
  return `${normalizeBotSymbol(symbol)}:${timeframe}`
}
